import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  feesTable: {
    marginTop: '32px'
  },
  smallCell: {
    width: '130px'
  },
  subCell: {
    position: 'relative',
    paddingLeft: '70px !important',
    '&:after': {
      content: '""',
      position: 'absolute',
      width: '30px',
      height: '1px',
      borderBottom: "1px dashed ".concat(palette.shades[600]),
      left: '30px',
      top: '50%'
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      width: '1px',
      height: '100%',
      top: '0',
      left: '30px',
      borderLeft: "1px dashed ".concat(palette.shades[600])
    }
  },
  lastSubCell: {
    '&:before': {
      height: '50%'
    }
  }
}));
export default useStyles;